import { render, staticRenderFns } from "./TprepQuizDashboard.vue?vue&type=template&id=5dee1823&scoped=true"
import script from "./TprepQuizDashboard.vue?vue&type=script&lang=js"
export * from "./TprepQuizDashboard.vue?vue&type=script&lang=js"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./TprepQuizDashboard.vue?vue&type=style&index=1&id=5dee1823&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dee1823",
  null
  
)

export default component.exports